import { useAppStore } from "@/store"
import { Button } from "@preview-kit/ui/components/button"
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@preview-kit/ui/components/select"
import { Separator } from "@preview-kit/ui/components/separator"
import { Switch } from "@preview-kit/ui/components/switch"
import { cn } from "@preview-kit/ui/lib/utils"
import { ArrowLeft } from "lucide-react"
import { useState } from "react"
import { useShallow } from "zustand/shallow"
import CommandListView from "../command-list"

export default function SettingsView() {
	const { setNavigation, setAnimateClick } = useAppStore(
		useShallow((state) => ({
			setNavigation: state.setNavigation,
			setAnimateClick: state.setAnimateClick,
		})),
	)

	const [alwaysActivate, setAlwaysActivate] = useState(false)
	const [startHidden, setStartHidden] = useState(false)
	const [notifications, setNotifications] = useState("replies-mentions")
	const [theme, setTheme] = useState("light")

	return (
		<>
			<div className={cn("flex-1 overflow-y-auto ", "scroll_area")}>
				<Button
					size="icon"
					className="absolute top-4 left-4 z-50 w-7 h-7 flex items-center justify-center bg-neutral-200"
					variant="outline"
					onClick={() => {
						setAnimateClick()
						setNavigation({
							currentView: <CommandListView />,
							breadcrumb: [],
							viewStack: [],
						})
					}}
				>
					<ArrowLeft />
				</Button>

				<div className="mt-4   ">
					<h1 className="text-xl px-4 ml-10  font-semibold text-gray-900">
						Preferences
					</h1>
					<Separator className="my-4" />
					<div className="space-y-6 text-black">
						{/* Chrome Extension */}
						{/* Always Activate */}
						<div className="space-y-2 px-4">
							<div className="flex items-center justify-between">
								<div>
									<h3 className="font-medium text-sm">Always Activate</h3>
									<p className="text-xs text-muted-foreground">
										Automatically activate the toolbar.
									</p>
								</div>
								<Switch
									checked={alwaysActivate}
									onCheckedChange={setAlwaysActivate}
								/>
							</div>
						</div>

						{/* Start Hidden */}
						<div className="space-y-2 px-4">
							<div className="flex items-center justify-between">
								<div className="flex-1">
									<h3 className="font-medium text-sm">Start Hidden</h3>
									<p className="text-xs text-muted-foreground">
										Hide the toolbar on load.
									</p>
									<p className="text-xs text-muted-foreground mt-1">
										You can use{" "}
										<kbd className="px-1 py-0.5 text-xs bg-muted rounded border">
											⌘ + K
										</kbd>{" "}
										to show it.
									</p>
								</div>
								<Switch
									checked={startHidden}
									onCheckedChange={setStartHidden}
								/>
							</div>
						</div>
						{/* Notifications */}
						<div className="space-y-2 px-4">
							<div className="flex items-center justify-between">
								<div>
									<h3 className="font-medium text-sm">Notifications</h3>
									<p className="text-xs text-muted-foreground">
										Which actions should send notifications.
									</p>
								</div>
								<Select value={notifications} onValueChange={setNotifications}>
									<SelectTrigger className="w-40 h-8 text-xs">
										<SelectValue />
									</SelectTrigger>
									<SelectContent
										container={window.__PREVIEWKIT_PORTAL_CONTAINER__}
									>
										<SelectItem value="replies-mentions">
											Replies & Mentions
										</SelectItem>
										<SelectItem value="all">All Notifications</SelectItem>
										<SelectItem value="none">None</SelectItem>
									</SelectContent>
								</Select>
							</div>
						</div>
						{/* Theme */}
						<div className="space-y-2 px-4">
							<div className="flex items-center justify-between">
								<div>
									<h3 className="font-medium text-sm">Theme</h3>
									<p className="text-xs text-muted-foreground">
										Select your theme preference.
									</p>
								</div>
								<Select value={theme} onValueChange={setTheme}>
									<SelectTrigger className="w-24 h-8 text-xs">
										<SelectValue />
									</SelectTrigger>
									<SelectContent
										container={window.__PREVIEWKIT_PORTAL_CONTAINER__}
									>
										<SelectItem value="light">Light</SelectItem>
										<SelectItem value="dark">Dark</SelectItem>
										<SelectItem value="system">System</SelectItem>
									</SelectContent>
								</Select>
							</div>
						</div>

						{/* <div className="space-y-2">
						<div className="flex items-center justify-between">
							<div>
								<h3 className="font-medium text-sm">Keyboard Shortcuts</h3>
								<p className="text-xs text-muted-foreground">
									View and assign custom key bindings.
								</p>
							</div>
							<Button
								variant="outline"
								size="sm"
								className="text-xs h-8 bg-transparent"
							>
								<Settings className="w-3 h-3 mr-1" />
								Configure
							</Button>
						</div>
					</div> */}
					</div>
				</div>
			</div>
		</>
	)
}
